export default function SearchForm() {
  const search = document.querySelector('.search-form');
  const openSearchButton = document.querySelector('.js-search-form');
  const closeSearchButton = document.querySelector('.search-form__button--close');
  const searchIsOpenClass = 'search-form--is-open';

  function openSearch() {
    search.classList.add(searchIsOpenClass);
    search.querySelector('input').focus();
  };

  function closeSearch () {
    search.classList.remove(searchIsOpenClass);
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.search-form') && !e.target.closest('.js-search-form')) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (e) { e.key === 'Escape' && closeSearch()});
  openSearchButton.addEventListener('click', () => openSearch());
  closeSearchButton.addEventListener('click', () => closeSearch());
};
